import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './Components/app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginComponent, ResetPasswordDialogComponent} from './Components/login/login.component';
import {HomeComponent} from './Components/home/home.component';
import {ChangePasswordDialogComponent, TopbarComponent} from './Components/topbar/topbar.component';
import {SpringRestModule} from '@aiknow-srl/aik-angular-sdk';
import {MatCardModule} from '@angular/material/card';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {MatSliderModule} from '@angular/material/slider';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMenuModule} from '@angular/material/menu';
import {MatTableModule} from '@angular/material/table';
import {DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule} from '@angular/material/core';
import {MatDividerModule} from '@angular/material/divider';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTabsModule} from '@angular/material/tabs';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import {
    AreUSureDeleteCustomerDialogComponent,
    ChangeCustomerOwnerDialogComponent,
    CustomerRegistryComponent,
    PutCustomerDialogComponent
} from './Components/customerRegistry/customerRegistry.component';
import {
    AreUSureDeleteUserDialogComponent,
    ChangeCustomerUserOwnerDialogComponent,
    CustomerUserRegistryComponent,
    PutCustomerUserDialogComponent
} from './Components/customerUserRegistry/customerUserRegistry.component';
import {MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MatAutocompleteModule} from '@angular/material/autocomplete';
import {CustomerDetailComponent} from './Components/customerRegistry/customerDetail/customerDetail.component';
import {
    CustomerUserDetailComponent
} from './Components/customerUserRegistry/customerUserDetail/customerUserDetail.component';
import {APP_DATE_FORMATS, AppDateAdapter} from './Utils/NgbDateCustomParserFormatter';
import {getItalianPaginatorIntl} from './Utils/PaginatorFormatter';
import {
    AreUSureDeleteE015UserDialogComponent,
    E015UserRegistryComponent,
    PutE015UserDialogComponent
} from './Components/e015UserRegistry/e015UserRegistry.component';
import {E015UserDetailComponent} from './Components/e015UserRegistry/e015UserDetail/e015UserDetail.component';
import {ClipboardModule} from "@angular/cdk/clipboard";
import { PublicMapComponent } from './Components/publicMap/publicMap.component';
import {GoogleMapsModule} from "@angular/google-maps";

import {
    AreUSureDeleteProductItemDialogComponent,
    ChangeCustomerProductItemOwnerDialogComponent,
    ChangeWorkflowStatusDialogComponent,
    CustomerProductItemRegistryComponent,
    ProductItemTokenDialogComponent,
    PutCustomerProductItemDialogComponent
} from "./Components/customerProductItemRegistry/customerProductItemRegistry.component";
import {
    AreUSureDeleteChirpstackDialogComponent,
    CustomerProductItemDetailComponent,
    PutProductItemE015ChargerDialogComponent
} from "./Components/customerProductItemRegistry/customerProductItemDetail/customerProductItemDetail.component";
import {
  AreUSureDeleteProductTypeDialogComponent,
  ProductTypeRegistryComponent,
  PutProductTypeDialogComponent
} from './Components/productTypeRegistry/productTypeRegistry.component';
import {
  AreUSureDeleteChargerDialogComponent,
  ChargerRegistryComponent,
  PutChargerDialogComponent
} from './Components/chargerRegistry/chargerRegistry.component';
import {
  ProductTypeDetailComponent
} from "./Components/productTypeRegistry/productTypeDetail/productTypeDetail.component";
import {ChargerDetailComponent} from "./Components/chargerRegistry/chargerDetail/chargerDetail.component";


export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/languages/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    TopbarComponent,
    ResetPasswordDialogComponent,
    PutCustomerDialogComponent,
    ChangeCustomerOwnerDialogComponent,
    ChangeCustomerUserOwnerDialogComponent,
    AreUSureDeleteCustomerDialogComponent,
    PutCustomerUserDialogComponent,
    AreUSureDeleteUserDialogComponent,
    PutE015UserDialogComponent,
    AreUSureDeleteE015UserDialogComponent,
    ChangePasswordDialogComponent,
    CustomerRegistryComponent,
    CustomerUserRegistryComponent,
    CustomerDetailComponent,
    CustomerUserDetailComponent,
    E015UserRegistryComponent,
    E015UserDetailComponent,
    ChangeWorkflowStatusDialogComponent,
    PublicMapComponent,
    CustomerProductItemRegistryComponent,
    PutCustomerProductItemDialogComponent,
    ChangeCustomerProductItemOwnerDialogComponent,
    AreUSureDeleteProductItemDialogComponent,
    ProductItemTokenDialogComponent,
    CustomerProductItemDetailComponent,
    PutProductItemE015ChargerDialogComponent,
    AreUSureDeleteChirpstackDialogComponent,
    ProductTypeRegistryComponent,
    ChargerRegistryComponent,
    PutProductTypeDialogComponent,
    ProductTypeDetailComponent,
    PutChargerDialogComponent,
    AreUSureDeleteChargerDialogComponent,
    ChargerDetailComponent,
    AreUSureDeleteProductTypeDialogComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        FlexLayoutModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        MatCardModule,
        MatSnackBarModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatSliderModule,
        MatCardModule,
        MatDialogModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatDividerModule,
        MatTabsModule,
        MatPaginatorModule,
        SpringRestModule,
        ClipboardModule,
        GoogleMapsModule,
        ReactiveFormsModule
    ],
    providers: [{ provide: MatPaginatorIntl, useValue: getItalianPaginatorIntl() },
        {provide: DateAdapter, useClass: AppDateAdapter},
        {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
        {provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, useValue: {requireSelection: true}}],
    bootstrap: [AppComponent]
})
export class AppModule { }
